'use client';

import { trackedEntity } from '@cineamo/pulse';
import { usePulseTracker } from '@cineamo/pulse/react';
import { useTranslations } from 'next-intl';

import { copyToClipboard } from '@cineamo/ui/src/helpers/clipboard-helper';

import { CachedContentData } from '@/hooks/useCachedContentData';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

/**
 * Shares the content's detail page: the native share sheet where the browser offers one, otherwise
 * the link lands in the clipboard with a toast.
 */
export default function useSharePageLink(content?: CachedContentData) {
    const t = useTranslations();
    const { track: pulseTrack } = usePulseTracker();
    const { track } = useAnalytics();

    return function sharePageLink() {
        const shareData = { url: `${globalThis.location.origin}/program/${content?.id}` };
        if (!navigator.canShare?.(shareData)) {
            copyToClipboard(shareData.url, t('showing-info.copied'));
            return;
        }
        navigator
            .share(shareData)
            .then(() => {
                track('Share Page Link Clicked', {
                    source: 'Content Title',
                    contentId: content?.id ?? ''
                });
                pulseTrack({
                    ...trackedEntity({ movieId: content?.movieId, contentId: content?.id ?? 0 }),
                    event_type: 'share',
                    context: { content_id: content?.id }
                });
            })
            .catch(() => {});
    };
}
